"use strict";

// eslint-disable-next-line no-unused-vars
function goComment(query) {
  const hrefValue = window.location.href.split('?')[0];
  const articleGallery = document.querySelector('.article-type-gallery');
  const stripPage = document.querySelector('.site_wrap--strip');
  let linkValue;
  if (articleGallery || stripPage) {
    linkValue = window.location.origin + document.querySelector('.thread_teaser').dataset.link;
  }
  if (typeof query === 'number') {
    if (query === 0) {
      if (window.getUserToken()) {
        window.location.href = linkValue ? `${linkValue}/komentari` : `${hrefValue}/komentari`;
      } else {
        window.openModalLogin();
      }
    } else {
      window.location.href = linkValue ? `${linkValue}/komentari` : `${hrefValue}/komentari`;
    }
  } else {
    window.location.href = linkValue ? `${linkValue}/komentari${query}` : `${hrefValue}/komentari${query}`;
  }
}
let commentTeaserFetchTriggered = false;
function showCommentTeaser(entries, observer) {
  entries.forEach(entry => {
    if (entry.isIntersecting && !commentTeaserFetchTriggered) {
      commentTeaserFetchTriggered = true;
      observer.disconnect();
      window.Unicorn.call('comment-teaser', 'show');
    }
  });
}
const commentTeaserObserver = new IntersectionObserver(showCommentTeaser, {
  rootMargin: '300px 0px 300px 0px'
});
document.addEventListener('DOMContentLoaded', () => {
  commentTeaserObserver.observe(document.querySelector('.js_commentTeaserTrigger'));
});